// src/pages/ChinhSachBaoMat.jsx
import React from "react";
import "./Privacy.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const Privacy = () => {
  return (
    <main className="policy-wrapper">
      <Navbar />
      <div className="policy-container">
        <h1 className="policy-title">Chính sách bảo mật thông tin</h1>

        <p>
          Website <strong>Thuận điện Lạnh Sài Gòn</strong> là trang web thuộc
          quyền sở hữu của Công ty Dịch Vụ Điện Lạnh Sài Gòn. Khi bạn truy cập
          vào website này https://ruttienthetindungso1.com/ ("Trang web") , đồng
          nghĩa là bạn đã đồng ý các quy định về chính sách bảo mật thông tin
          sau đây.
        </p>

        <h2>1. Chính sách bảo mật đối với khách hàng</h2>
        <p>
          Điện Lạnh Sài Gòn cam kết giữ bí mật tuyệt đối mọi thông tin cá nhân
          của khách hàng, trừ khi có sự đồng ý từ phía khách hàng hoặc các cơ
          quan chức năng có thẩm quyền theo quy định pháp luật.
        </p>

        <h2>2. Chính sách về thu thập thông tin của khách hàng</h2>
        <p>
          Nhằm phục vụ cho quá trình thực hiện dịch vụ, chúng tôi có thể yêu cầu
          khách hàng cung cấp một số thông tin như: họ tên, số điện thoại, địa
          chỉ, email… và một số thông tin liên quan khác.
        </p>
        <p>
          Tùy theo sự thay đổi về dịch vụ của Điện Lạnh Sài Gòn, chúng tôi có
          thể sửa đổi, bổ sung các điều khoản trên tại chính sách bảo mật này và
          sẽ thông báo trên website khi có cập nhật.
        </p>

        <h2>3. Mục đích thu thập thông tin cá nhân của khách hàng</h2>
        <p>Thông tin khách hàng được thu thập với các mục đích sau:</p>
        <ul>
          <li>Thực hiện dịch vụ sửa chữa, bảo trì theo yêu cầu khách hàng.</li>
          <li>Bảo hành sau khi sửa chữa, chăm sóc khách hàng sau dịch vụ.</li>
          <li>
            Thông báo về các chương trình ưu đãi, khuyến mãi dành cho khách hàng
            cũ (nếu khách hàng đồng ý nhận thông tin).
          </li>
          <li>
            Khảo sát ý kiến khách hàng nhằm nâng cao chất lượng dịch vụ &amp;
            trải nghiệm trên website.
          </li>
          <li>Thanh toán, đối soát chi phí với khách hàng.</li>
        </ul>

        <h2>4. Phạm vi sử dụng thông tin của khách hàng</h2>
        <p>
          Thông tin của khách hàng chỉ được sử dụng trong phạm vi nội bộ của
          công ty và các mục đích đã nêu ở trên. Điện Lạnh Sài Gòn chỉ cung cấp
          thông tin của khách hàng trong một số trường hợp đặc biệt sau:
        </p>
        <ul>
          <li>Khi có yêu cầu từ các cơ quan nhà nước có thẩm quyền.</li>
          <li>
            Khi việc cung cấp thông tin là cần thiết để bảo vệ quyền và lợi ích
            hợp pháp của Điện Lạnh Sài Gòn trước pháp luật.
          </li>
          <li>
            Tình huống khẩn cấp cần thiết để bảo vệ quyền an toàn cá nhân của
            khách hàng hoặc các thành viên tại Điện Lạnh Sài Gòn.
          </li>
        </ul>

        <h2>5. Thời gian lưu trữ thông tin</h2>
        <p>
          Thông tin khách hàng được lưu trữ tối thiểu <strong>01 năm</strong> kể
          từ lần giao dịch gần nhất hoặc cho đến khi khách hàng có yêu cầu hủy
          bỏ thông tin qua các kênh liên hệ chính thức.
        </p>

        <h2>6. Những bộ phận có thể tiếp cận được với thông tin</h2>
        <p>
          Thông tin của khách hàng chỉ được cung cấp cho những bộ phận liên quan
          đến quá trình cung cấp dịch vụ, bao gồm:
        </p>
        <ul>
          <li>Bộ phận tiếp nhận thông tin &amp; tổng đài CSKH.</li>
          <li>Bộ phận kỹ thuật, thợ sửa chữa.</li>
          <li>Bộ phận chăm sóc khách hàng, marketing.</li>
          <li>Ban giám đốc và bộ phận quản lý cấp cao khi cần thiết.</li>
        </ul>

        <h2>7. Đơn vị thu thập và quản lý thông tin</h2>
        <p>
          <strong>Công ty Dịch Vụ Điện Lạnh Sài Gòn</strong>
        </p>
        <p>
          <strong>Địa chỉ:</strong> 379/69 Nguyễn Kiệm, Phường 9, Phú Nhuận,
          Thành phố Hồ Chí Minh
        </p>
        <p>
          <strong>Điện thoại:</strong> 0994 307 835
        </p>
        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:Xecuocmientay227@gmail.com">
            Xecuocmientay227@gmail.com
          </a>
        </p>

        <h2>8. Liên hệ chỉnh sửa thông tin</h2>
        <p>
          Nếu khách hàng muốn xem lại, chỉnh sửa hoặc hủy bỏ thông tin cá nhân
          đã cung cấp, vui lòng liên hệ với chúng tôi qua:
        </p>
        <ul>
          <li>
            Điện thoại: <strong>0994 307 835</strong>
          </li>
          <li>
            Email:{" "}
            <a href="mailto:Xecuocmientay227@gmail.com">
              Xecuocmientay227@gmail.com
            </a>
          </li>
        </ul>

        <h2>9. Liên hệ khiếu nại</h2>
        <p>
          Khi có khiếu nại, phản ánh về việc thông tin cá nhân bị sử dụng sai
          mục đích hoặc không an toàn, khách hàng có thể liên hệ:
        </p>
        <ul>
          <li>
            Điện thoại tiếp nhận khiếu nại: <strong>0994 307 835</strong>
          </li>
          <li>
            Email:{" "}
            <a href="mailto:Xecuocmientay227@gmail.com">
              Xecuocmientay227@gmail.com
            </a>
          </li>
        </ul>

        <p className="policy-note">
          Mọi thay đổi về chính sách bảo mật sẽ được cập nhật tại trang này.
          Khách hàng vui lòng thường xuyên truy cập để nắm các thông tin mới
          nhất.
        </p>
      </div>
      <Footer />
    </main>
  );
};

export default Privacy;
